import { LuIcon } from "@overmap-ai/blocks"

import { modelIconMapping } from "../../../mappings/icons"
import { TextFilterDef } from "../TextFilterDef"

export class ProjectNameFilterDef extends TextFilterDef {
	readonly id = "project-name"
	readonly icon = <LuIcon icon={modelIconMapping.text} />
	readonly label = "Name"
}
